export const DROP_DOWN_OPTIONS = [
  { label: 'SEARCH_NO_SORT', value: '0' },
  { label: 'SEARCH_SORT_BY_NAME', value: '2' },
  { label: 'SEARCH_SORT_BY_PART_NUMBER', value: '1' }
];

export const MOBILE_DROP_DOWN_OPTIONS = [
  { label: 'SN_NO_SORT', value: '0' },
  { label: 'SN_SORT_BY_NAME', value: '2' },
  { label: 'SEARCH_RESULTS_FOR', value: '1' }
];
